import type { AllRequest, TableConfig } from "../../../types/tables";

import {
  assigneeCell,
  brandCell,
  createdByCell,
  dateCell,
  dueDateCellColored,
  nameCell,
  requestDesignTypeCell,
  statusCell,
} from "../../helpers/commonCells";

// All Tab Configuration (original structure with reordered columns)
export const allTableConfig: TableConfig<AllRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 240,
    },
    {
      accessor: "assignee",
      cellRenderer: assigneeCell,
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: 160,
    },
    {
      accessor: "customerDueDate",
      cellRenderer: dueDateCellColored,
      header: "Due",
      key: "customerDueDate",
      sortable: true,
      width: 120,
    },
    {
      accessor: "status",
      cellRenderer: statusCell,
      header: "Status",
      key: "status",
      sortable: true,
      width: 180,
    },
    {
      accessor: "brand",
      cellRenderer: brandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: 160,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created By",
      key: "createdBy",
      sortable: true,
      width: 140,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 140,
    },
    {
      accessor: "requestType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "requestType",
      sortable: true,
      width: 180,
    },
  ],
  defaultSort: {
    column: "createdAt",
    direction: "desc",
  },
  enableSorting: true,
  id: "all-requests",
  title: "All Requests",
};
